<!-- 各类动作提示 -->
<template>
  <div class="ActionTip">
    <el-dialog
      class="PopupBox"
      :title="LoopDialog.Operation == 'delete' ? $t('lang.DeleteRecurringEvent') : $t('lang.EditRecurringEvent')"
      :visible.sync="LoopDialog.switch"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="600px"
      top="25vh">
      <div
        class="ThisBooking"
        v-for="(item, index) in LoopOptions"
        :key="index">
        <div class="LeftSwitch" style="margin-bottom: 10px;">
          <el-radio v-model="LoopSelete" :label="item.value"><span style="color: #DBDBDB; font-size: 14px;" v-html="$t(`lang.${item.key}`)"></span> </el-radio>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="LoopDialog.switch = false">
          {{ $t("lang.cancel") }}</el-button>
        <el-button
          type="primary"
          @click="ConfirmEvent">{{ $t("lang.ConfirmBtn") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    LoopDialog: {
      type: Object,
      default: () => {
        return {
          switch: false,
          Operation: 'delete' // delete 删除事件  update 更新事件
        }
      }
    }
  },
  data () {
    return {
      //  选择循环事件
      LoopSelete: 0,
      // 选择
      LoopOptions: [
        {
          key: 'ThisEvent',
          value: 0
        },
        {
          key: 'AllEvents',
          value: 2
        }
      ]
    }
  },
  created () {
  },
  mounted () { },
  methods: {
    // 确定什么操作
    ConfirmEvent () {
      // 判断
      if (this.LoopDialog.Operation == 'delete') {
        this.$emit('deleteLoopEvent', this.LoopSelete)
      } else if (this.LoopDialog.Operation == 'update') {
        this.$emit('updateLoopEvent', this.LoopSelete)
      }
      this.LoopDialog.switch = false
    }
  }
}
</script>

<style scoped lang="less">

</style>
